// src/components/ViewAsPicker.js
//
// Admin picks who to "View as". Only Tech-role people (subs included) are
// listed: office accounts can send team messages and approve work, so
// viewing as them is left out on purpose.

import React, { useMemo, useState } from "react";
import { isSubcontractor } from "../utils/contractorIdentity";

const box = {
  position: "fixed",
  zIndex: 10050,
  left: "50%",
  top: "50%",
  transform: "translate(-50%, -50%)",
  width: "min(520px, 94vw)",
  maxHeight: "80vh",
  display: "flex",
  flexDirection: "column",
  background: "#fff",
  borderRadius: 14,
  boxShadow: "0 20px 50px rgba(15,23,42,0.3)",
  padding: 16,
  textAlign: "left",
};

const rowBtn = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  gap: 10,
  width: "100%",
  textAlign: "left",
  background: "#fff",
  backgroundImage: "none",
  color: "#0f172a",
  border: "none",
  borderBottom: "1px solid #e2e8f0",
  borderRadius: 0,
  boxShadow: "none",
  padding: "10px 6px",
  margin: 0,
  fontSize: 15,
  cursor: "pointer",
};

const ViewAsPicker = ({ users = [], onPick, onClose }) => {
  const [q, setQ] = useState("");

  const people = useMemo(() => {
    const needle = q.trim().toLowerCase();
    return users
      .filter((u) => u.role === "Tech")
      .map((u) => ({
        u,
        name: `${u.firstName || ""} ${u.lastName || ""}`.trim() || u.email || u.id,
      }))
      .filter((p) => !needle || p.name.toLowerCase().includes(needle) || String(p.u.email || "").toLowerCase().includes(needle))
      .sort((a, b) => a.name.localeCompare(b.name));
  }, [users, q]);

  return (
    <>
      <div
        onClick={onClose}
        style={{ position: "fixed", inset: 0, background: "rgba(15,23,42,0.5)", zIndex: 10049 }}
      />
      <div style={box} role="dialog" aria-modal="true" aria-label="View as">
        <div style={{ display: "flex", justifyContent: "space-between", alignItems: "center", marginBottom: 6 }}>
          <strong style={{ fontSize: 18 }}>View as…</strong>
          <button type="button" className="red-button" style={{ width: "auto", padding: "6px 14px" }} onClick={onClose}>
            Close
          </button>
        </div>
        <p style={{ margin: "0 0 10px", fontSize: 13, color: "#475569" }}>
          See Home exactly as this person sees it: their jobs, clock, check-ins, language and pay.
          It's read-only, so nothing you click will save. Use Exit in the orange bar to come back.
        </p>
        <input
          type="search"
          value={q}
          onChange={(e) => setQ(e.target.value)}
          placeholder="Search by name"
          style={{ width: "100%", marginBottom: 8, boxSizing: "border-box" }}
          autoFocus
        />
        <div style={{ overflowY: "auto", flex: 1 }}>
          {people.length === 0 && <div style={{ color: "#64748b", padding: 8 }}>No one matches.</div>}
          {people.map(({ u, name }) => (
            <button
              key={u.id}
              type="button"
              style={rowBtn}
              onClick={() =>
                onPick({
                  uid: u.authUid || u.id,
                  docId: u.id,
                  name,
                  role: u.role,
                  language: u.language,
                })
              }
            >
              <span>
                <strong>{name}</strong>
                {isSubcontractor(u) && (
                  <span style={{ marginLeft: 8, fontSize: 11, fontWeight: 800, color: "#9a3412", background: "#ffedd5", borderRadius: 6, padding: "2px 6px" }}>
                    Sub
                  </span>
                )}
              </span>
              <span style={{ fontSize: 12, color: "#64748b" }}>{u.language === "es" ? "Español" : "English"}</span>
            </button>
          ))}
        </div>
      </div>
    </>
  );
};

export default ViewAsPicker;
